'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _debounce = require('lodash/debounce');var _debounce2 = _interopRequireDefault(_debounce);

var _OMAutocompleteInput = require('../../OMComponents/OMAutocompleteInput/OMAutocompleteInput');var _OMAutocompleteInput2 = _interopRequireDefault(_OMAutocompleteInput);

var _constants = require('../../../constants');
var _analyticsManager = require('../../../utils/analytics/analyticsManager');
var _checkers = require('../../../utils/checkers');
var _analyticsConstants = require('../../../utils/analytics/analyticsConstants');

var _MapContainerLocationInput = require('./MapContainerLocationInput.scss');var styles = _interopRequireWildcard(_MapContainerLocationInput);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var MapContainerLocationInput = function (_Component) {_inherits(MapContainerLocationInput, _Component);function MapContainerLocationInput(props) {_classCallCheck(this, MapContainerLocationInput);var _this = _possibleConstructorReturn(this, _Component.call(this, props));_this.




    state = {
      suggestions: [],
      value: '',
      lastSearchHistory: [],
      currentSuggestion: null };_this.


    componentDidMount = function () {
      if (_constants.storage.value.getItem('lastSearchHistory')) {
        _this.setState({
          lastSearchHistory: JSON.parse(_constants.storage.value.getItem('lastSearchHistory')) // eslint-disable-line
        });
      }
      if (_this.props.locationValue) {
        _this.getAutocompleteSuggestions(_this.props.locationValue);
      }
    };_this.





    getSuggestionValue = function (suggestion) {
      _this.setState({ currentSuggestion: suggestion });
      return suggestion.description;
    };_this.


    getAutocompleteSuggestions = function (newValue) {
      if (!_this.props.googleService) {return null;}
      return _this.props.googleService.autocompleteLocus(newValue).
      then(function (suggestions) {
        if (!suggestions.length) {
          _this.tryAutocompleteGoogle(newValue);
        } else {
          _this.setState({ suggestions: suggestions });
        }
      }).
      catch(function () {return _this.tryAutocompleteGoogle(newValue);});
    };_this.

    getInputValue = function (value) {
      var stateModifier = { value: value };
      if (typeof value === 'string' && value.length === 0) {
        stateModifier.suggestions = [];
      }
      _this.setState(stateModifier);

      if (value.trim().length > 0) {
        _this.getAutocompleteSuggestions(value);
      }
    };_this.

    tryAutocompleteGoogle = function (newValue) {
      var promise = _this.props.googleService.autocompleteGoogle(newValue);
      if (promise instanceof Promise) {
        promise.
        then(function (results) {
          _this.lastAutocompleteResult = results;
          _this.setState({ suggestions: results });
          _this.trackSearch(newValue);
        }).
        catch(function (err) {
          _this.props.googleService.handleError(err);
          _this.setState({
            suggestions: _this.lastAutocompleteResult ?
            _this.lastAutocompleteResult : _this.state.lastSearchHistory });

        });
      }
    };_this.

    searching = function () {
      if (_this.state.suggestions[0] || _this.state.currentSuggestion) {
        var firstSuggestion = _this.state.suggestions[0];
        var suggestionDescription = firstSuggestion && firstSuggestion.description ? firstSuggestion.description.toLowerCase() : '';
        var sameSuggestion = suggestionDescription.indexOf(_this.state.value.toLowerCase()) !== -1;
        var suggestion = sameSuggestion ? _this.state.suggestions[0] : _this.state.currentSuggestion;

        if (suggestion) {
          _this.setState({ value: suggestion }, function () {return _this.searchSelectedOption(suggestion);});
        }

        (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.searchResults, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel.search);
      }
    };_this.

    searchSelectedOption = function (obj) {
      _this.saveInHistory(obj);
      _this.setState({
        value: obj.description },
      function () {
        var geocode = obj.tags ?
        _this.props.googleService.performGeocodeLocusByInnerBase(obj.tags, obj.address, obj.type) :
        _this.props.googleService.geocodeLocusViaGoogle(obj.place_id);
        geocode.then(_this.props.getInputData);
      });
    };_this.

    saveInHistory = function (suggestion) {
      if (suggestion) {
        var suggestionIsUnique = true;
        _this.state.lastSearchHistory.forEach(function (item) {
          if (
          suggestion.id && item.id === suggestion.id ||
          suggestion.place_id && item.place_id === suggestion.place_id)
          {
            suggestionIsUnique = false;
          }
        });

        if (suggestionIsUnique) {
          suggestion.isSearchHistory = true;
          if (_this.state.lastSearchHistory.length < 5) {
            _this.state.lastSearchHistory.unshift(suggestion);
          } else {
            _this.state.lastSearchHistory.pop();
            _this.state.lastSearchHistory.unshift(suggestion);
          }
          _constants.storage.value.setItem('lastSearchHistory', JSON.stringify(_this.state.lastSearchHistory));
        }
      }
    };_this.

    trackSearch = function (value) {
      (0, _analyticsManager.trackPage)('/search?cat=map&q=' + value);
    };_this.trackSearch = (0, _debounce2.default)(_this.trackSearch.bind(_this), 1000);_this.getAutocompleteSuggestions = (0, _debounce2.default)(_this.getAutocompleteSuggestions, 500, { leading: false });return _this;}MapContainerLocationInput.prototype.shouldComponentUpdate = function shouldComponentUpdate(newProps, newState) {return !(0, _isEqual2.default)({ p: newProps, s: newState }, { p: this.props, s: this.state });};MapContainerLocationInput.prototype.

  renderAutocomleteInput = function renderAutocomleteInput() {
    return (
      _react2.default.createElement(_OMAutocompleteInput2.default, {
        theme: _constants.inputStyleTheme,
        placeholder: this.props.placeholder,
        getInputValue: this.getInputValue,
        suggestions: this.state.suggestions.length > 0 ? this.state.suggestions : this.state.lastSearchHistory,
        getSuggestionValue: this.getSuggestionValue,
        selectedSuggestion: this.searchSelectedOption,
        shouldRenderSuggestions: function shouldRenderSuggestions() {return true;},
        deferRequestBy: 300,
        inputValue: this.props.locationValue,
        initialValue: this.props.locationValue,
        isValid: true,
        isDeferredBlur: true }));


  };MapContainerLocationInput.prototype.

  render = function render() {var _cx,_this2 = this;
    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(styles.addressInput, (_cx = {}, _cx[styles.largeSideBar] = this.props.isLargeSideBar, _cx)),
          ref: function ref(parentInput) {_this2.parentInput = parentInput;} },

        _react2.default.createElement('div', { className: styles.locationInput },
          this.props.mapIsReady && this.renderAutocomleteInput(),
          _react2.default.createElement('span', { className: styles.searchIcon },
            _react2.default.createElement('i', { className: 'icon icon-search' })))));







  };return MapContainerLocationInput;}(_react.Component);


MapContainerLocationInput.propTypes = {
  placeholder: _propTypes2.default.string,
  // buttonTitle: PropTypes.string,
  getInputData: _propTypes2.default.func,
  mapIsReady: _propTypes2.default.bool,
  locationValue: _propTypes2.default.string,
  googleService: _propTypes2.default.object,
  autocompleteGoogle: _propTypes2.default.func,
  isLargeSideBar: _propTypes2.default.bool };exports.default =


MapContainerLocationInput;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LocationInput/MapContainerLocationInput/MapContainerLocationInput.js
// module id = 1219
// module chunks = 0